import { Alert, Button } from '@efexteam/components';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useTranslation } from 'react-i18next';
import { Spacings10 } from '@efexteam/design-tokens';
import { TABS } from '../../constants';
import ContinueBarStyles from './ContinueBar.style';
import useContinueBar from './hooks/useContinueBar.service';
import { ContinueBarProps } from './types';

const ContinueBar = ({
  setActiveTabsArray,
  goToActiveTab,
  onCancel,
  activeTabs,
  currentStep,
  canContinue,
}: ContinueBarProps) => {
  const { t } = useTranslation();
  const {
    loading,
    error,
    goToAssignRoleStep,
    goToAddMemberStep,
    createNewMember,
    createMember,
  } = useContinueBar({
    setActiveTabsArray,
    goToActiveTab,
    activeTabs,
  });

  const renderTabContent = () => {
    switch (currentStep) {
      case TABS.ADD_MEMBER:
        return (
          <>
            <Button appearance="secondary" onClick={onCancel}>
              {t('cancel')}
            </Button>
            <Button
              appearance="primary"
              type="submit"
              disabled={!canContinue}
              endIcon={<ArrowForwardIcon />}
              onClick={goToAssignRoleStep}
            >
              {t('continue')}
            </Button>
          </>
        );
      case TABS.ASSIGN_ROLE:
        return (
          <>
            <Button
              disabled={loading}
              appearance="secondary"
              onClick={goToAddMemberStep}
            >
              {t('back')}
            </Button>
            <Button
              disabled={loading || !canContinue}
              appearance="primary"
              color={error ? 'error' : 'primary'}
              onClick={createMember}
              endIcon={loading && <RefreshIcon className="animate-spin" />}
            >
              {t('createMember')}
            </Button>
          </>
        );
      case TABS.CONFIRM_MEMBER:
        return (
          <Button appearance="primary" onClick={createNewMember}>
            {t('createNewMember')}
          </Button>
        );
      default:
        return null;
    }
  };

  return (
    <>
      {error && (
        <Alert
          sx={{
            marginTop: Spacings10,
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
          variant="outlined"
          severity="error"
        >
          {typeof (error as any).response?.data?.detail === 'string'
            ? (error as any).response?.data?.detail
            : error.message}
        </Alert>
      )}
      <div className={ContinueBarStyles.wrapper}>{renderTabContent()}</div>
    </>
  );
};

export default ContinueBar;
